document.addEventListener("DOMContentLoaded", () => {
    let counter = 1;

    const header = document.querySelector(".header");
    const sections = document.querySelectorAll("section");
    
    const firstBanner = document.querySelector('.section-banner-one, .section-banner-two');
    const isSpecialHeader = header && (header.classList.contains('header-one') || header.classList.contains('header-two'));
    
    const updateBannerHeight = (bannerElement) => {
        const headerHeight = header.offsetHeight;
        const viewportHeight = window.innerHeight;
        bannerElement.style.height = `${viewportHeight - headerHeight}px`;
    };

    const updateAllBannersHeight = () => {
        const banners = document.querySelectorAll('.section-banner-one, .section-banner-two');
        
        if (isSpecialHeader && firstBanner) {
            banners.forEach(banner => {
                if (banner !== firstBanner) {
                    updateBannerHeight(banner);
                }
            });
        } else if (!isSpecialHeader) {
            banners.forEach(banner => updateBannerHeight(banner));
        }
    };

    sections.forEach((section) => {
        if (!section.classList.contains('content-title')) {
            section.id = `section-${counter}`;
            counter++;
        }
        
        if (section.classList.contains('section-banner-one') || section.classList.contains('section-banner-two')) {
            updateAllBannersHeight();
            
            window.addEventListener('resize', updateAllBannersHeight);
        }
    });
});